import { Component, AfterViewInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { Motivo } from '../../../../models';

import { MotivosService, LoginService } from '../../../../services/';

@Component({
  selector: 'qs-motivos',
  templateUrl: './motivosconsulta.component.html',
  styleUrls: ['./motivosconsulta.component.scss'],
  viewProviders: [MotivosService],
})
export class MotivosConsultaComponent implements AfterViewInit, OnDestroy {

  private _xsScreen: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'texto', label: 'Motivo', tooltip: 'Motivo', sortable: false },
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: true },
    { name: 'hora', label: 'Hora', tooltip: 'Hora', sortable: false },
    { name: 'numeroExpediente', label: 'Núm. Exp.', sortable: false, hidden: true },
    { name: 'visita', label: 'Visita', sortable: false, hidden: true },
    { name: 'colegiado', label: 'Colegiado', sortable: false, hidden: true },
    { name: 'dniMedico', label: 'DNI', sortable: false, hidden: true },
    { name: 'numeroMotivo', label: 'Num. Motivo', sortable: false, hidden: true },
    { name: 'seguimiento', label: 'Seguimiento', sortable: false, hidden: true },
    { name: 'linea', label: 'Linea', tooltip: 'Linea', sortable: false, hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;
  public motivos: any[];

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _motivosService: MotivosService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this._loadingService.register('motivosconsulta.load');
    this._motivosService.obtenerMotivos(
      this._loginService.consulta.numeroExpediente,
      this._loginService.consulta.visita,
    ).subscribe((res: any) => {
      this.motivos = res.respuesta.motivos;
      this.filteredData = this.motivos;
      this.filteredDataTotal = this.motivos.length;
      this._loadingService.resolve('motivosconsulta.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
      this._loadingService.resolve('motivosconsulta.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   * xs < 600px
   * sm > 600px
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          if (this.tableComponent !== undefined) {
            this.tableComponent.refresh();
          }
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          if (this.tableComponent !== undefined) {
            this.tableComponent.refresh();
          }
        }
      });
    });
  }

  openDetalleAlta(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
    { outlets: { hojadeseguimiento: ['motivosdetalle'] } }]);
  }

  /**
   * openDetalle: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetalle(motivo: Motivo): void {
    if (motivo) {
      this._loginService.transient = motivo;
      this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
      { outlets: { hojadeseguimiento: ['motivosdetalle'] } }]);
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.motivos;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/motivosconsulta/motivosconsulta.component.ts